import { render, staticRenderFns } from "./DowngradeSubscription.vue?vue&type=template&id=95a59916&"
import script from "./DowngradeSubscription.vue?vue&type=script&lang=js&"
export * from "./DowngradeSubscription.vue?vue&type=script&lang=js&"
import style0 from "./DowngradeSubscription.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports